import { useGetAllAnnotationsPaginatedQuery } from 'store/apis/annotationsApi';
import { removeDuplicatesByUuid } from 'utilities/array';

export const useGetAnnotations = (pageNumber, pageSize) => {
  const { isFetching, data = {} } = useGetAllAnnotationsPaginatedQuery({
    page: pageNumber,
    count: pageSize,
  });

  const { count, results: annotations } = data;

  const uniqueAnnotations = removeDuplicatesByUuid(annotations);

  return {
    count,
    annotations: uniqueAnnotations,
    isLoading: isFetching,
  };
};
